







































import { ActorTypes } from '@/data/models/actor.model';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class AttoreFilter extends Vue {

	@Prop() entityfilter!: string;

	advancedSearch: Search;
	searchParam: any = new class {
		name: string = '';
		surname: string = '';
		email: string = '';
	};
	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('actor');
	}

	mounted() {
		if(this.entityfilter) {
			this.filterByActorType();
		}
	}

	@Watch('entityfilter')
	onEntityFilterChange() {
		this.filterByActorType();
		this.search();
	}

	search() {
		this.advancedSearch.reset();
		if(this.entityfilter) {
			this.filterByActorType();
		}
		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		if (this.searchParam.name) this.advancedSearch.addLikeFilter('name', this.searchParam.name);
		if (this.searchParam.surname) this.advancedSearch.addLikeFilter('surname', this.searchParam.surname);
		if (this.searchParam.email) this.advancedSearch.addLikeFilter('email', this.searchParam.email);

		this.$emit('search', this.advancedSearch);
	}

	filterByActorType() {
		
		switch(this.entityfilter) {
		case ActorTypes.VOLUNTEER: 
			this.advancedSearch.addNotEqualFilter('volunteerid', null);
			break;
		case ActorTypes.ASSOCIATE: 
			this.advancedSearch.addNotEqualFilter('associateid', null);
			break;
		case ActorTypes.PATIENT: 
			this.advancedSearch.addNotEqualFilter('patientid', null);
			break;
		case ActorTypes.DOCTOR: 
			this.advancedSearch.addNotEqualFilter('doctorid', null);
			break;
		}
		
	}

	reset() {
		this.searchParam.name = undefined;
		this.searchParam.surname = undefined;
		this.searchParam.email = undefined;
		this.search();
	}
}
